import { createTheme } from "@mui/material";

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "Rubik",
    },
  },
  palette: {
    secondary: {
      main: "#79a206",
    },
  },
});

export default theme;
